import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostBinding,
    HostListener,
    Input,
    Output
} from '@angular/core';
import { Photo } from '../models/photo.viewmodel';

@Component({
    selector: 'tm-list-photo-card',
    templateUrl: './photo-card.component.html',
    styleUrls: ['./photo-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PhotoCardComponent {
    @Input()
    public photo: Photo;

    @HostBinding('class.tm-list-photo-card--activatable')
    @Input()
    public activatable: boolean;

    @Input()
    public isThumbnail = false;

    @Output()
    public activate: EventEmitter<Photo> = new EventEmitter<Photo>();

    @HostListener('click')
    @HostListener('keydown.enter')
    @HostListener('keydown.space')
    public onActivated(): void {
        if (this.activatable && !this.photo.loading) {
            this.activate.emit(this.photo);
        }
    }

    public get url(): string | null {
        return this.photo.transformedPhoto?.plusSize || this.photo?.plusSize;
    }
}
